//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import {
  SOURCE_FILTER_VALUES,
  VALID_BAZAARVOICE_NETWORK_SOURCES,
} from '@galleries/models/galleriesStateModel';

export const getValidBazaarvoiceNetworkSources = createSelector(
  (state: ICuralateStore) => !!state.session.features.rights_management_page,
  (isRightsManagementEnabled): SOURCE_FILTER_VALUES[] => {
    if (isRightsManagementEnabled) {
      return VALID_BAZAARVOICE_NETWORK_SOURCES;
    } else {
      return VALID_BAZAARVOICE_NETWORK_SOURCES.filter(
        (value) => value !== SOURCE_FILTER_VALUES.RIGHTS_NEEDED,
      );
    }
  },
);
